import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/* Wraps protected workspaces and routes users to the right onboarding step
   based on their `onboarding_step` and `role`. Use AFTER ProtectedRoute. */
export default function OnboardingGate({ children, expect }) {
  const { user } = useAuth();
  if (!user) return children; // ProtectedRoute will handle

  const step = user.onboarding_step || "role";

  // No role yet → role chooser
  if (!user.role || step === "role") {
    return <Navigate to="/onboarding/role" replace />;
  }
  // Candidate without profile → setup
  if (user.role === "candidate" && step === "profile") {
    return <Navigate to="/onboarding/profile" replace />;
  }
  // Company without workspace → onboarding
  if (user.role === "company" && step === "company") {
    return <Navigate to="/company/onboarding" replace />;
  }
  // Role mismatch → send the user to their own workspace
  if (expect && user.role !== expect) {
    const home = user.role === "company" ? "/company" : user.role === "agency" ? "/agency" : user.role === "college" ? "/campus" : "/app";
    return <Navigate to={home} replace />;
  }
  return children;
}
